<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
    <div class="phone-show btn-phone">
      <div class="">
        <div style="font-size: 20px;" @click="clickPhone">联系电话：400-117-1567</div>
        <div style="font-size: 11px;">7*24小时人工客服电话，节假日不休息</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  //通过路由规则，进入该组件时被调用
  beforeRouteEnter(to,from,next) {
    console.log(11111)
    next()
    // if(toString.meta.isAuth){
    //   if(localStorage.getTime('school')==='qinghuadaxue'){
    //     next()
    //   }else{
    //     alert('学校名不对，无权限查看！')
    //   }
    // } else{
    //   next()
    // }
  },
  
  //通过路由规则，离开该组件时被调用 
  beforeRouteLeave(to,from,next) {
    next()
  },
  created(){
    
  },
  methods:{
    clickPhone(){
      window.location.href = 'tel:400-117-1567'
    }
  }
}

</script>

<style>
  .public-header-img{
    width: 100%;
  }
  img{
    width: 100%;
  }
  .public-content-text{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
  }
  @media screen and (min-width: 996px){
    .computer-show{
      display: block;
    }
    .phone-show{
      display: none;
    }
    .public-content{
      padding-left: 240px;
      padding-right: 240px;
      margin-top: 50px;
      overflow: hidden;
      display: flex;
      align-items: center;
    }
    .img-jjfa{
      width: 127px;
      height: 31px;
    }
    .img-public{
      width: 35%;
    }
    .public-header-title {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999999999;
      width: 100%;
      color: #fff;
      /* background: rgba(51, 51, 51, 0.534); */
      text-align: center;
      line-height: 80px;
    }
    .public-header-title > h1{
      font-size: 32px;
      margin-top: 10%;
      line-height: 50px;
    }
    .public-header-title > p{
      font-size: 16px;
      margin-top: 10px;
      font-weight: 500;
      line-height: 36px;
      color: #F5F5F5;
    }
  }
  /* 媒体查询（手机） */
  @media screen and (max-width: 996px) {
    .computer-show{
      display: none;
    }
    .phone-show{
      display: block;
    }
    .public-box{
      padding: 20px 0;
    }
    .public-content{
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 20px;
      overflow: hidden;
      display: flex;
      align-items: center;
      flex-direction:column;
    }
    .img-jjfa{
      width: 100%;
    }
    .img-public{
      width: 100%;
    }
    .header-img-box{
      width: 100%;
      height: 175px;
    }
    .public-header-img{
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    .public-header-title {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999999999;
      width: 100%;
      color: #fff;
      /* background: rgba(51, 51, 51, 0.534); */
      text-align: center;
    }
    .public-header-title > h1{
      font-size: 26px;
      margin-top: 10%;
      line-height: 50px;
    }
    .public-header-title > p{
      font-size: 15px;
      margin-top: 10px;
      font-weight: 500;
      line-height: 36px;
      color: #F5F5F5;
    }
    .btn-phone{
      position: fixed;
      bottom: 90px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #2A62F5;
      width: 80%;
      z-index: 999;
      border-radius: 50px;
      color: #fff;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue